// extracted by css-extract-rspack-plugin
export default {"skeleton":"_Mthuh4SgWEZ81Td","skeleton-animation":"kNYfMYKaFqELlsAJ","skeletonChild":"UTZHCgp9COwb_f2H"};